import React from 'react';
import { useReveal } from '../lib/useReveal';
const PAIN_POINTS = ['Estás cansada de una manera que el descanso no cura', 'Sentís que tu cuerpo te habla pero no sabés cómo escucharlo', 'La ansiedad aparece sin razón aparente y no tenés herramientas para bajarla', 'Probaste cosas sueltas que no conectan entre sí y te dejan igual', 'Querés reconectar con tu energía femenina pero no sabés por dónde empezar', 'El estrés y las emociones no procesadas se acumulan sin salida real', 'Tu vínculo de pareja está bajo presión y no sabés cómo comunicarte desde el amor', 'Cada mes el ciclo te golpea más fuerte y nadie te explica el origen emocional'];
export function ProblemSection() {
  const [ref1, vis1] = useReveal();
  const [ref2, vis2] = useReveal();
  return <section className="bg-brand-card py-8 md:py-10 px-5 sm:px-6 border-t border-brand-border-soft" data-id="element-217">
      <div className="container mx-auto max-w-3xl" data-id="element-218">
        <div ref={ref1} className={`reveal ${vis1 ? 'is-visible' : ''}`} data-id="element-219">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-6 leading-tight text-brand-heading text-center" data-id="element-220">
            ¿Cuánto tiempo más vas a postergar tu bienestar?
          </h2>

          <div className="space-y-4 text-lg text-brand-body leading-relaxed text-center mb-5" data-id="element-221">
            <p data-id="element-222">
              Sentís el llamado hace tiempo. Sabés que algo necesita cambiar.
              Pero nunca encontraste un sistema completo, serio y profundamente
              femenino que te diera todo en un solo lugar.
            </p>
            <p className="font-bold text-brand-heading text-xl" data-id="element-223">
              No es falta de voluntad. Es falta de un sistema.
            </p>
          </div>
        </div>

        <div ref={ref2} className={`reveal space-y-3 mb-6 ${vis2 ? 'is-visible' : ''}`} data-id="element-224">
          {PAIN_POINTS.map((point, i) => <div key={i} className="flex items-start gap-3 bg-white p-4 rounded-xl border border-brand-border-soft shadow-sm" data-id="element-225">
              <span className="text-brand-cta flex-shrink-0 mt-0.5 font-bold" data-id="element-226">
                ✗
              </span>
              <p className="text-brand-body text-base sm:text-lg" data-id="element-227">{point}</p>
            </div>)}
        </div>

        <div className="text-center" data-id="element-228">
          <p className="text-brand-cta font-display italic font-bold text-2xl md:text-3xl" data-id="element-229">
            ¿Y si este fuera el último día que postergás tu reconexión?
          </p>
        </div>
      </div>
    </section>;
}